var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_155_2896)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.0008 20.625C15.1782 20.625 15.3265 20.5651 15.4459 20.4453C15.5653 20.3255 15.625 20.1771 15.625 20V14.375C15.625 14.1979 15.565 14.0495 15.4451 13.9297C15.3251 13.8099 15.1765 13.75 14.9992 13.75C14.8218 13.75 14.6735 13.8099 14.5541 13.9297C14.4347 14.0495 14.375 14.1979 14.375 14.375V20C14.375 20.1771 14.435 20.3255 14.5549 20.4453C14.6749 20.5651 14.8235 20.625 15.0008 20.625ZM15 11.9712C15.218 11.9712 15.4007 11.8974 15.5481 11.75C15.6955 11.6026 15.7692 11.4199 15.7692 11.2019C15.7692 10.984 15.6955 10.8013 15.5481 10.6538C15.4007 10.5064 15.218 10.4327 15 10.4327C14.782 10.4327 14.5993 10.5064 14.4519 10.6538C14.3045 10.8013 14.2308 10.984 14.2308 11.2019C14.2308 11.4199 14.3045 11.6026 14.4519 11.75C14.5993 11.8974 14.782 11.9712 15 11.9712ZM15.0042 26.25C13.4485 26.25 11.9859 25.9548 10.6164 25.3644C9.24685 24.774 8.05555 23.9727 7.04247 22.9606C6.02941 21.9485 5.2274 20.7583 4.63644 19.3901C4.04548 18.0218 3.75 16.5599 3.75 15.0042C3.75 13.4485 4.0452 11.9859 4.63559 10.6164C5.22601 9.24685 6.02728 8.05555 7.03941 7.04247C8.05153 6.02941 9.24171 5.2274 10.6099 4.63644C11.9782 4.04548 13.4401 3.75 14.9958 3.75C16.5515 3.75 18.0141 4.0452 19.3836 4.63559C20.7531 5.22601 21.9444 6.02728 22.9575 7.03941C23.9706 8.05153 24.7726 9.24171 25.3636 10.6099C25.9545 11.9782 26.25 13.4401 26.25 14.9958C26.25 16.5515 25.9548 18.0141 25.3644 19.3836C24.774 20.7531 23.9727 21.9444 22.9606 22.9575C21.9485 23.9706 20.7583 24.7726 19.3901 25.3636C18.0218 25.9545 16.5599 26.25 15.0042 26.25ZM15 25C17.7917 25 20.1562 24.0312 22.0938 22.0938C24.0312 20.1562 25 17.7917 25 15C25 12.2083 24.0312 9.84375 22.0938 7.90625C20.1562 5.96875 17.7917 5 15 5C12.2083 5 9.84375 5.96875 7.90625 7.90625C5.96875 9.84375 5 12.2083 5 15C5 17.7917 5.96875 20.1562 7.90625 22.0938C9.84375 24.0312 12.2083 25 15 25Z",
  fill: "currentColor"
}));
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_155_2896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_155_2896)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_155_2896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _ref3), _ref4));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.73e22296.svg";
export { ForwardRef as ReactComponent };